module.exports = __webpack_public_path__ + "static/media/1POLICY11.e56f2097.jpg";